import React, { Component } from "react";
import ArrowButton from "../../../common/button-arrow";
import { validators } from "../../../../utils/validators";
import {
  Checkbox,
  Col,
  FormControl,
  Row,
  FormGroup,
  ControlLabel,
  Radio,
} from "react-bootstrap";
import { Errors, Form, Control } from "react-redux-form";
import RequiredInput from "../../../common/form/elements/required-input";
import ImageUpload from "../../../common/form/elements/image-upload";
import RequiredTextarea from '../../../common/form/elements/required-textarea';
import RequiredDatePicker from '../../../common/form/elements/required-datepicker';
import DatePicker from '../../../common/form/datepicker';
import { connect } from "react-redux";

class AssessmentForm extends Component {
  render() {
    const { formValid, model, onSubmit, assessment } = this.props;

    const attributes = assessment.attributes;
    let image = undefined;
    let startDate, endDate, displayFromDate, displayToDate = '';

    if (attributes) {
      image = attributes.link ? attributes.link.image : undefined;
      startDate = attributes['start-date'];
      endDate = attributes['end-date'];
      displayFromDate = attributes['display-from-date'];
      displayToDate = attributes['display-to-date'];
    }

    return (
          <Form model={model} onSubmit={onSubmit}>
            <Row>
              <Col md={12}>
                <Errors className="errors" model={model} />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <RequiredInput
                  label="Name"
                  placeholder="Name"
                  model=".name"
                  controlId="name"
                />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <RequiredDatePicker model="deep.admin_assessment_save.start_date"
                                    value={startDate}
                                    label="Start date"
                                    placeholder="Select a date..."
                                    controlId="startDate"/>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <DatePicker model="deep.admin_assessment_save.end_date"
                                    value={endDate}
                                    label="End date"
                                    placeholder="Select a date..."
                                    controlId="endDate"/>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <RequiredTextarea model=".criteria"
                                label="Criteria"/>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <RequiredDatePicker model="deep.admin_assessment_save.display_from_date"
                                    value={displayFromDate}
                                    label="Display from date"
                                    placeholder="Select a date..."
                                    controlId="displayFromDate"/>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <DatePicker model="deep.admin_assessment_save.display_to_date"
                                    value={displayToDate}
                                    label="Display to date"
                                    placeholder="Select a date..."
                                    controlId="displayToDate"/>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <ImageUpload source={image}
                             sizeLimit={1024 * 1024}
                             type={['image/png', 'image/jpg', 'image/jpeg']}
                             model=".image" />
              </Col>
            </Row>
            <Row>
              <Col md={2} mdOffset={10}>
                <ArrowButton
                  className="pull-right"
                  arrow={false}
                  disabled={!formValid}
                >
                  Save
                </ArrowButton>
              </Col>
            </Row>
          </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  formValid: state.deep.forms.admin_assessment_save.$form.valid,
});

export default connect(mapStateToProps)(AssessmentForm);



// WEBPACK FOOTER //
// ./src/components/admin/assessments/form/assessment-form.jsx